import { useRef } from 'react'
import { Loader } from 'semantic-ui-react'
import { FEATURE_FLAG_KEYS } from '@/flags'
import { useLoadedFlagValue } from '@/utils/sharedHooks'
import MonthlyBooksPanel from './MonthlyBooksPanel'
import MonthlyBooksPanelLegacy from './MonthlyBooksPanelLegacy'

/**
 * An unresolved read never drops the panel, because the panel sets a reconciliation
 * context on mount and that leaves the flag unresolved: swapping to the loader would
 * unmount it and set the context again without end. A real change to the flag still
 * swaps, so it stays usable on an open tab.
 */
export const MonthlyBooksPanelSwitch = () => {
  const declaredActions = useLoadedFlagValue<boolean>(
    FEATURE_FLAG_KEYS.enableDeclaredReconciliationActions,
    false
  )
  const resolved = useRef<boolean | null>(null)
  if (declaredActions !== null) {
    resolved.current = declaredActions
  }

  if (resolved.current === null) return <Loader active inline="centered" />

  return resolved.current ? <MonthlyBooksPanel /> : <MonthlyBooksPanelLegacy />
}

export default MonthlyBooksPanelSwitch
